module.exports = {
  "country": "GE",
  "artist": "Nuza Busladse",
  "song": "Firefighter",
  "year": "2024",
  "place": "21",
  "spotify": "7FkBgheyWxe37GIREat9YB"
};